<div class="tiles-section section--fluent consumer-tiles-section">
    <div class="width-restrictor width-restrictor--responsive">
        <ohp-app-tiles-list></ohp-app-tiles-list>
    </div>
</div>
